var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"vbutton",staticClass:"vue-button",class:[
          _vm.type ? 'vue-button--' + _vm.type : '',
          _vm.size ? 'vue-button--' + _vm.size : '',
          {
            'is-disabled': _vm.disabled,
            'is-loading': _vm.loading,
            'is-activated': _vm.activated
          }
],attrs:{"disabled":_vm.disabled || _vm.loading,"type":_vm.nativeType},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('span',{class:{hidden: _vm.loading, show: !_vm.loading}},[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"vue-button-loading"},[_c('i',{staticClass:"iconfont iconloading loading-item"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }